import adminReducer from "@/components/activity/admin/ducks/reducer"
import { combineReducers } from "@reduxjs/toolkit"

const activityReducer = combineReducers({
  admin: adminReducer,
})

export default activityReducer
